import React from "react";
import Link from "next/link";

type ShallowRenderingWrapperProps = {
  enabled: boolean;
  href: string;
  children?: React.ReactNode;
};

export const ShallowRenderingWrapper: React.FC<
  ShallowRenderingWrapperProps
> = ({ children, enabled, href }) => {
  if (enabled) {
    return <Link href={href}>{children}</Link>;
  } else {
    return <>{children}</>;
  }
};
